import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useSingleResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useSingleResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedArtifactResource,
    IndirectlyVersionedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';
import { IdSchema } from '../../../resource-base/baseSchemas';

export enum ProcessAreaActivityAssociationPropertyValidation {
    ACTIVITY = 'ACTIVITY',
}

export const ProcessAreaActivityAssociationResourceSchema = IndirectlyVersionedArtifactResourceSchema.extend({
    resourceType: z
        .literal(ResourceType.PROCESS_AREA_ACTIVITIES_ASSOCIATION)
        .default(ResourceType.PROCESS_AREA_ACTIVITIES_ASSOCIATION),
    activities: IdSchema,
});
export const ProcessAreaActivityAssociationMutationResourceSchema = getMutationSchema(
    ProcessAreaActivityAssociationResourceSchema
);

export type ProcessAreaActivityAssociationResource = z.infer<typeof ProcessAreaActivityAssociationResourceSchema>;

export const defaultProcessAreaActivityAssociationResource: ProcessAreaActivityAssociationResource = {
    ...defaultIndirectlyVersionedArtifactResource,
    resourceType: ResourceType.PROCESS_AREA_ACTIVITIES_ASSOCIATION,
    activities: '',
};

export function useProcessAreaActivityAssociationActions() {
    return {
        ...useSingleResourceSingleParentedResourceAdapterActions(
            'project/process-area-activities-association',
            ResourceType.PROCESS_AREA_ACTIVITIES_ASSOCIATION,
            ProcessAreaActivityAssociationResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/process-area-activities-association',
            ResourceType.PROCESS_AREA_ACTIVITIES_ASSOCIATION,
            ProcessAreaActivityAssociationResourceSchema
        ),
    };
}
